import React from 'react';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Button,
} from '@mui/material';

const ProviderDialog = ({
  open,
  editingProvider,
  form,
  onChange,
  onClose,
  onSave,
  roleOptions,
  childOptions = [],
  currentChildId = '',
  selectedChildIds = [],
  onSelectedChildIdsChange,
  showChildSelection = false,
}) => {
  const selectedChildren = childOptions.filter((child) => selectedChildIds.includes(child.id));

  const handleChildChange = (event) => {
    onSelectedChildIdsChange?.(typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{editingProvider ? 'Edit provider' : 'Add provider'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {!editingProvider && showChildSelection ? (
            <FormControl fullWidth>
              <InputLabel id="provider-child-label">Add provider for</InputLabel>
              <Select
                multiple
                labelId="provider-child-label"
                label="Add provider for"
                value={selectedChildIds}
                onChange={handleChildChange}
                renderValue={(value) => {
                  const labels = childOptions
                    .filter((child) => value.includes(child.id))
                    .map((child) => child.name || 'Child');
                  return labels.join(', ');
                }}
              >
                {childOptions.map((child) => (
                  <MenuItem key={child.id} value={child.id}>
                    <Checkbox checked={selectedChildIds.includes(child.id)} />
                    <ListItemText
                      primary={child.name || 'Child'}
                      secondary={child.id === currentChildId ? 'Current child' : undefined}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : null}

          <TextField
            label="Provider name"
            value={form.name}
            onChange={(event) => onChange('name', event.target.value)}
            fullWidth
            required
          />

          <FormControl fullWidth>
            <InputLabel id="provider-role-label">Role</InputLabel>
            <Select
              labelId="provider-role-label"
              label="Role"
              value={form.role}
              onChange={(event) => onChange('role', event.target.value)}
            >
              {roleOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Specialty"
            value={form.specialty}
            onChange={(event) => onChange('specialty', event.target.value)}
            fullWidth
          />
          <TextField
            label="Organization / practice"
            value={form.organizationName}
            onChange={(event) => onChange('organizationName', event.target.value)}
            fullWidth
          />
          <TextField
            label="Phone"
            value={form.phone}
            onChange={(event) => onChange('phone', event.target.value)}
            fullWidth
          />
          <TextField
            label="Email"
            value={form.email}
            onChange={(event) => onChange('email', event.target.value)}
            fullWidth
          />
          <TextField
            label="Address"
            value={form.address}
            onChange={(event) => onChange('address', event.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
          <TextField
            label="Notes"
            value={form.notes}
            onChange={(event) => onChange('notes', event.target.value)}
            fullWidth
            multiline
            minRows={3}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSave} disabled={!form.name.trim() || (!editingProvider && selectedChildren.length === 0)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProviderDialog;
